module.exports = __webpack_public_path__ + "static/img/load.4236ddfd.gif";